import { render, staticRenderFns } from "./ValidatorSummaryTab.vue?vue&type=template&id=6e44596e&"
import script from "./ValidatorSummaryTab.vue?vue&type=script&lang=js&"
export * from "./ValidatorSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports